import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider, useApp } from "@/context/AppContext";
import { AppShell } from "@/components/AppShell";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Profile from "@/pages/Profile";
import ScholarshipExplorer from "@/pages/ScholarshipExplorer";
import ScholarshipDetail from "@/pages/ScholarshipDetail";
import TestPage from "@/pages/Test";
import CostCalculator from "@/pages/CostCalculator";
import BenefitExplorer from "@/pages/BenefitExplorer";
import Roadmap from "@/pages/Roadmap";
import SuccessStories from "@/pages/SuccessStories";
import Settings from "@/pages/Settings";

import Access from "@/pages/access/Access";
import ProductDashboard from "@/pages/access/ProductDashboard";
import ProductView from "@/pages/access/ProductView";
import Admin from "@/pages/access/Admin";
import AccessRequired from "@/pages/AccessRequired";

function Guard({ children }) {
  const { user, entitled, data, ready } = useApp();
  const loc = useLocation();
  if (!ready) return <div className="flex min-h-screen items-center justify-center text-[#7C3AED]">Memuat…</div>;
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  // Paid product: only a verified Lynk payment (ACTIVE entitlement) unlocks the app.
  if (!entitled) return <Navigate to="/akses" replace />;
  if (!data.onboardingComplete && loc.pathname !== "/onboarding") return <Navigate to="/onboarding" replace />;
  return children;
}

function Shell({ children }) {
  return <Guard><AppShell>{children}</AppShell></Guard>;
}

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/daftar" element={<Register />} />
            <Route path="/lupa-password" element={<ForgotPassword />} />
            <Route path="/akses" element={<AccessRequired />} />
            <Route path="/onboarding" element={<Guard><Onboarding /></Guard>} />

            <Route path="/app" element={<Shell><Dashboard /></Shell>} />
            <Route path="/app/profil" element={<Shell><Profile /></Shell>} />
            <Route path="/app/beasiswa" element={<Shell><ScholarshipExplorer /></Shell>} />
            <Route path="/app/beasiswa/:id" element={<Shell><ScholarshipDetail /></Shell>} />
            <Route path="/app/test" element={<Shell><TestPage /></Shell>} />
            <Route path="/app/kalkulator" element={<Shell><CostCalculator /></Shell>} />
            <Route path="/app/benefit" element={<Shell><BenefitExplorer /></Shell>} />
            <Route path="/app/roadmap" element={<Shell><Roadmap /></Shell>} />
            <Route path="/app/kisah-sukses" element={<Shell><SuccessStories /></Shell>} />
            <Route path="/app/pengaturan" element={<Shell><Settings /></Shell>} />

            {/* Standalone digital-product access system (independent of Scholavia) */}
            <Route path="/access" element={<Access />} />
            <Route path="/dashboard" element={<ProductDashboard />} />
            <Route path="/product/:productId" element={<ProductView />} />
            <Route path="/admin" element={<Admin />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AppProvider>
    </div>
  );
}

export default App;
